<ng-container *ngIf="isShowBaggageRule">
  <!-- [1.6.1] 手荷物ルール -->
  <div [id]="scrollId">
    <div class="p-heading-area01">
      <h2 class="c-heading-2" role="heading" aria-level="2" [innerHTML]="'label.rule' | staticMsg"></h2>
    </div>

    <!-- [1.6.11] 手荷物ルール -->
    <ng-container *ngIf="isShowBaggageRules">
      <!-- [1.6.12] 預入手荷物ルール -->
      <div [ngClass]="['p-plan-table js-plan-table01-item', isScrollCheckedBaggage ? 'is-scroll' : '']">
        <div class="p-plan-table__title p-plan-table__title--has-btn">
          <div class="p-plan-table__title-label p-plan-table__title-label--em p-plan-table__title-label--l">
            <asw-text-with-tooltip
              [tooltipText]="'label.checkedBaggage2' | staticMsg"
              [tooltipContent]="'tooltip.checkedBaggage' | staticMsg"
              [displayHelperIcon]="false"
            ></asw-text-with-tooltip>
          </div>
        </div>
        <div class="p-plan-table__contents">
          <div class="p-plan-table__scroll">
            <asw-table-slider id="checked-baggage-slider" (isScrollChange)="scrollChangeCheckedBaggage($event)">
              <div class="p-plan-table__scroll-view">
                <div class="p-plan-table__scroll-inner js-plan-table01-scroll" #detailPanel>
                  <table
                    class="c-plan-table01 c-plan-table01--6col js-plan-table01"
                    id="checked-baggage-table"
                    #scrollPanel
                  >
                    <caption class="u-visually-hidden">
                      Checked baggage
                    </caption>
                    <thead class="c-plan-table01__head">
                      <tr class="c-plan-table01__inner">
                        <td class="c-plan-table01__col"><div class="c-plan-table01__col-inner"></div></td>
                        <!-- PNR情報取得API応答.data.travelersのtravelerIdを取得して搭乗者IDリストを作成する。-->
                        <!-- <以下、運賃ルール・手荷物情報取得API応答.data.baggagePolicies.baggageAllowance.<搭乗者IDリスト[0]>.baggageBounds[]の要素数繰り返し>(それぞれの要素が当該) -->
                        <ng-container *ngFor="let baggageBound of getBaggageBoundsByDefault()">
                          <th class="c-plan-table01__col" scope="col">
                            <div class="c-plan-table01__col-inner">
                              <div class="c-plan-table01__col-item c-plan-table01__col--em">
                                <span class="c-flight-info01__title-airport">
                                  <!-- [1.6.14] 出発地 -->
                                  <span class="c-flight-info01__title-airport-departure">
                                    {{
                                      getPointOfDepartureArrival(
                                        baggageBound?.departure?.locationCode ?? '',
                                        baggageBound.departure?.locationName ?? ''
                                      )
                                    }}
                                    <span class="c-flight-info01__title-airport-to">
                                      <span class="u-visually-hidden">to</span>
                                      <span aria-hidden="true" [innerHTML]="'label.hyphen' | staticMsg"></span>
                                    </span>
                                  </span>
                                  <!-- /[1.6.14] 出発地 -->
                                  <!-- [1.6.15] 到着地 -->
                                  <span class="c-flight-info01__title-airport-arrival">
                                    {{
                                      getPointOfDepartureArrival(
                                        baggageBound?.arrival?.locationCode ?? '',
                                        baggageBound.arrival?.locationName ?? ''
                                      )
                                    }}
                                  </span>
                                  <!-- /[1.6.15] 到着地 -->
                                </span>
                              </div>
                            </div>
                          </th>
                        </ng-container>
                        <!-- <ここまで、運賃ルール・手荷物情報取得API応答.data.baggagePolicies.baggageAllowance.<搭乗者IDリスト[0]>.baggageBounds[]の要素数繰り返し> -->
                      </tr>

                      <tr class="c-plan-table01__inner">
                        <th class="c-plan-table01__col" scope="row">
                          <div class="c-plan-table01__col-inner">
                            <div
                              class="c-plan-table01__col-item c-plan-table01__col-item--gray60"
                              [innerHTML]="'label.applidCarrier' | staticMsg"
                              *ngIf="isShowCarrierNameByUSDOTOrCADOT"
                            ></div>
                          </div>
                        </th>
                        <!-- PNR情報取得API応答.data.travelersのtravelerIdを取得して搭乗者IDリストを作成する。-->
                        <!-- <以下、運賃ルール・手荷物情報取得API応答.data.baggagePolicies.baggageAllowance.<搭乗者IDリスト[0]>.baggageBounds[]の要素数繰り返し>(それぞれの要素が当該) -->
                        <ng-container *ngFor="let baggageBound of getBaggageBoundsByDefault()">
                          <td class="c-plan-table01__col" style="transform: translate(0px, 0px)">
                            <div class="c-plan-table01__col-inner">
                              <!-- [1.6.16] ルール適用キャリア名 -->
                              <div
                                class="c-plan-table01__col-item c-plan-table01__col-item--fs16"
                                *ngIf="isShowCarrierNameByUSDOTOrCADOT"
                              >
                                {{
                                  getCarrierNameByUSDOTOrCADOT(
                                    baggageBound?.checkedBaggageAllowance?.airlineCode,
                                    baggageBound?.checkedBaggageAllowance?.airlineName
                                  )
                                }}
                              </div>
                              <!-- /[1.6.16] ルール適用キャリア名 -->
                              <!-- [1.6.17] ルール詳細コンテンツ -->
                              <asw-link-label
                                *ngIf="isNhGroupOperatingByUSDOTOrCADOT(baggageBound, CHECKEDBAGGAGE)"
                                [class]="'c-plan-table01__col-item c-plan-table01__col-item--fs16'"
                                [label]="'label.checkedBaggageAllownance.nhLink'"
                              ></asw-link-label>
                              <div
                                *ngIf="isNhGroupOperatingByIATARESO302"
                                class="c-plan-table01__col-item c-plan-table01__col-item--fs16"
                                [innerHTML]="
                                  getIsNhGroupOperatingByIATARESO302(CHECKEDBAGGAGE, baggageBound) | staticMsg
                                "
                              ></div>
                              <!-- /[1.6.17] ルール詳細コンテンツ -->
                            </div>
                          </td>
                        </ng-container>
                        <!-- <ここまで、運賃ルール・手荷物情報取得API応答.data.baggagePolicies.baggageAllowance.<搭乗者IDリスト[0]>.baggageBounds[]の要素数繰り返し> -->
                      </tr>
                    </thead>
                    <tbody class="c-plan-table01__body">
                      <!-- <以下、PNR情報取得API応答.data.travelers[]の要素数繰り返し>(それぞれの要素が当該搭乗者情報) -->
                      <ng-container *ngFor="let traveler of orderData.travelers">
                        <!-- [1.6.18] 搭乗者別ルール: 席なし幼児も1搭乗者として表示する。-->
                        <tr class="c-plan-table01__inner">
                          <th class="c-plan-table01__col c-plan-table01__col--pb0" scope="row">
                            <div class="c-plan-table01__col-inner">
                              <!-- [1.6.19] 搭乗者姓名 -->
                              <div class="c-plan-table01__col-item c-plan-table01__col-item--em">
                                {{ showTravelerName(traveler) | passengerName }}
                              </div>
                              <!-- /[1.6.19] 搭乗者姓名 -->
                              <!-- [1.6.20] 搭乗者種別 -->
                              <div
                                lass="c-plan-table01__col-item"
                                [innerHTML]="passengerLabel(traveler.passengerTypeCode) | staticMsg"
                              ></div>
                              <!-- [1.6.20] 搭乗者種別 -->
                            </div>
                          </th>
                          <!-- <以下、運賃ルール・手荷物情報取得API応答.data.baggagePolicies.baggageAllowance.<当該搭乗者情報.id>.baggageBounds[]の要素数繰り返し>(それぞれの要素が当該搭乗者情報) -->
                          <ng-container *ngFor="let baggageBound of getBaggageBoundsByPassengerId(traveler.id)">
                            <!-- 1)預入手荷物ルールのグループについて、当該適用区間情報.checkedBaggageAllowanceが存在する場合、当該適用区間情報.checkedBaggageAllowance(以下当該手荷物ルール情報とする)を使用して表示する -->
                            <!-- [1.6.21] 区間別ルール -->
                            <td
                              class="c-plan-table01__col c-plan-table01__col--pb0"
                              style="transform: translate(0px, 0px)"
                            >
                              <div class="c-plan-table01__col-inner">
                                <!-- [1.6.22] 無料手荷物個数 -->
                                <div
                                  class="c-plan-table01__col-item c-plan-table01__col-item--fs16"
                                  *ngIf="isShowCheckedBaggageAllowance(baggageBound)"
                                >
                                  <span class="c-plan-table01__icon-available">
                                    <span
                                      class="c-plan-table01__icon-available-image"
                                      *ngIf="getAllowanceQuantity(baggageBound, checkedBaggage) !== ''"
                                    >
                                      <img
                                        src="assets/images/icon_feature_not_available_24.svg"
                                        width="24"
                                        height="24"
                                        [alt]="'Alt.BaggageDepositNotAllowed' | staticMsg"
                                        *ngIf="quantityCheckedBaggageAllowance(baggageBound) === 0"
                                      />
                                      <img
                                        src="assets/images/icon_feature_available_24.svg"
                                        width="24"
                                        height="24"
                                        [alt]="'Alt.baggageDepositAvailable' | staticMsg"
                                        *ngIf="quantityCheckedBaggageAllowance(baggageBound) >= 1"
                                      />
                                    </span>
                                    <span class="c-plan-table01__icon-available-text">
                                      {{ getAllowanceQuantity(baggageBound, checkedBaggage) }}
                                    </span>
                                  </span>
                                </div>
                                <!-- /[1.6.22] 無料手荷物個数 -->
                              </div>
                            </td>
                            <!-- /[1.6.21] 区間別ルール -->
                          </ng-container>
                          <!-- <ここまで、運賃ルール・手荷物情報取得API応答.data.baggagePolicies.baggageAllowance.<当該搭乗者情報.id>.baggageBounds[]の要素数繰り返し> -->
                        </tr>
                        <!-- /[1.6.18] 搭乗者別ルール: 席なし幼児も1搭乗者として表示する。-->

                        <!-- [1.6.23] ルール詳細 -->
                        <ng-container *ngIf="!isShowDetailsByUSDOTOrCADOT && orderData.travelers">
                          <ng-container *ngFor="let bag of bags; index as bagIndex">
                            <tr
                              class="c-plan-table01__inner"
                              *ngIf="!isEmptyAllowanceDetails(bagIndex, traveler.id, CHECKEDBAGGAGEALLOWANCE)"
                            >
                              <th
                                class="c-plan-table01__col c-plan-table01__col--pb0 c-plan-table01__col--not-border"
                                scope="row"
                              >
                                <div class="c-plan-table01__col-inner">
                                  <div class="c-plan-table01__col-item--gray60" [innerHTML]="bag | staticMsg"></div>
                                </div>
                              </th>
                              <!-- <以下、運賃ルール・手荷物情報取得API応答.data.baggagePolicies.baggageAllowance.<当該搭乗者情報.id>.baggageBounds[]の要素数繰り返し>(それぞれの要素が当該搭乗者情報) -->
                              <ng-container *ngFor="let baggageBound of getBaggageBoundsByPassengerId(traveler.id)">
                                <td
                                  class="c-plan-table01__col c-plan-table01__col--pb0 c-plan-table01__col--not-border"
                                  style="transform: translate(0px, 0px)"
                                >
                                  <div class="c-plan-table01__col-inner">
                                    <!-- [1.6.24] 料金 -->
                                    <div class="c-plan-table01__col-item c-plan-table01__col-item--fs16">
                                      {{ getFeeDetail(baggageBound.checkedBaggageAllowance?.details ?? [], bagIndex) }}
                                    </div>
                                    <!-- /[1.6.24] 料金 -->
                                    <!-- [1.6.25] フリーテキスト -->
                                    <div
                                      class="c-plan-table01__col-item c-plan-table01__col-item--fs16"
                                      [innerHTML]="
                                        getDescriptionDetail(
                                          baggageBound.checkedBaggageAllowance?.details ?? [],
                                          bagIndex,
                                          CHECKEDBAGGAGE
                                        )
                                      "
                                    ></div>
                                    <!-- /[1.6.25] フリーテキスト -->
                                  </div>
                                </td>
                                <!-- /[1.6.23] ルール詳細 -->
                              </ng-container>
                              <!-- <ここまで、運賃ルール・手荷物情報取得API応答.data.baggagePolicies.baggageAllowance.<当該搭乗者情報.id>.baggageBounds[]の要素数繰り返し> -->
                            </tr>
                          </ng-container>
                        </ng-container>
                        <!-- /[1.6.23] ルール詳細 -->
                      </ng-container>
                      <!-- <ここまで、PNR情報取得API応答.data.travelers[]の要素数繰り返し> -->
                    </tbody>
                  </table>
                </div>
              </div>
            </asw-table-slider>
          </div>
        </div>
      </div>
      <!-- /[1.6.12] 預入手荷物ルール -->

      <!-- [1.6.26] 機内持ち込み手荷物ルール -->
      <div [ngClass]="['p-plan-table js-plan-table01-item', isScrollCarryOnBaggage ? 'is-scroll' : '']">
        <div class="p-plan-table__title p-plan-table__title--has-btn">
          <div class="p-plan-table__title-label p-plan-table__title-label--em p-plan-table__title-label--l">
            <asw-text-with-tooltip
              [tooltipText]="'label.carryOnBaggage2' | staticMsg"
              [tooltipContent]="'tooltip.carryOnBaggage' | staticMsg"
              [displayHelperIcon]="false"
            ></asw-text-with-tooltip>
          </div>
        </div>
        <div class="p-plan-table__contents">
          <div class="p-plan-table__scroll">
            <asw-table-slider id="carry-on-baggage-slider" (isScrollChange)="scrollChangeCarryOnBaggage($event)">
              <div class="p-plan-table__scroll-view">
                <div class="p-plan-table__scroll-inner js-plan-table01-scroll" #detailPanel>
                  <table
                    class="c-plan-table01 c-plan-table01--6col js-plan-table01"
                    id="carry-on-baggage-table"
                    #scrollPanel
                  >
                    <caption class="u-visually-hidden">
                      Carry-onBaggage baggage
                    </caption>
                    <thead class="c-plan-table01__head">
                      <tr class="c-plan-table01__inner">
                        <td class="c-plan-table01__col"><div class="c-plan-table01__col-inner"></div></td>
                        <!-- PNR情報取得API応答.data.travelersのtravelerIdを取得して搭乗者IDリストを作成する。-->
                        <!-- <以下、運賃ルール・手荷物情報取得API応答.data.baggagePolicies.baggageAllowance.<搭乗者IDリスト[0]>.baggageBounds[]の要素数繰り返し>(それぞれの要素が当該預入手荷物ルール情報) -->
                        <ng-container *ngFor="let baggageBound of getBaggageBoundsByDefault()">
                          <th class="c-plan-table01__col" scope="col" style="transform: translate(0px, 0px)">
                            <div class="c-plan-table01__col-inner">
                              <div class="c-plan-table01__col-item c-plan-table01__col--em">
                                <span class="c-flight-info01__title-airport">
                                  <!-- [1.6.26]-[1.6.14] 出発地 -->
                                  <span class="c-flight-info01__title-airport-departure">
                                    {{
                                      getPointOfDepartureArrival(
                                        baggageBound?.departure?.locationCode ?? '',
                                        baggageBound.departure?.locationName ?? ''
                                      )
                                    }}
                                    <span class="c-flight-info01__title-airport-to">
                                      <span class="u-visually-hidden">to</span>
                                      <span aria-hidden="true">-</span>
                                    </span>
                                  </span>
                                  <!-- /[1.6.26]-[1.6.14] 出発地 -->
                                  <!-- [1.6.26]-[1.6.15] 到着地 -->
                                  <span class="c-flight-info01__title-airport-arrival">
                                    {{
                                      getPointOfDepartureArrival(
                                        baggageBound?.arrival?.locationCode ?? '',
                                        baggageBound.arrival?.locationName ?? ''
                                      )
                                    }}
                                  </span>
                                  <!-- /[1.6.26]-[1.6.15] 到着地 -->
                                </span>
                              </div>
                            </div>
                          </th>
                        </ng-container>
                        <!-- <ここまで、運賃ルール・手荷物情報取得API応答.data.baggagePolicies.baggageAllowance.<搭乗者IDリスト[0]>.baggageBounds[]の要素数繰り返し> -->
                      </tr>
                      <tr class="c-plan-table01__inner">
                        <th class="c-plan-table01__col" scope="row">
                          <div class="c-plan-table01__col-inner">
                            <div
                              class="c-plan-table01__col-item c-plan-table01__col-item--gray60"
                              [innerHTML]="'label.applidCarrier' | staticMsg"
                              *ngIf="isShowCarrierNameByUSDOTOrCADOT"
                            ></div>
                          </div>
                        </th>
                        <!-- PNR情報取得API応答.data.travelersのtravelerIdを取得して搭乗者IDリストを作成する。-->
                        <!-- <以下、運賃ルール・手荷物情報取得API応答.data.baggagePolicies.baggageAllowance.<搭乗者IDリスト[0]>.baggageBounds[]の要素数繰り返し>(それぞれの要素が当該預入手荷物ルール情報) -->
                        <ng-container *ngFor="let baggageBound of getBaggageBoundsByDefault()">
                          <td class="c-plan-table01__col" style="transform: translate(0px, 0px)">
                            <div class="c-plan-table01__col-inner">
                              <!-- [1.6.26]-[1.6.16] ルール適用キャリア名 -->
                              <div
                                class="c-plan-table01__col-item c-plan-table01__col-item--fs16"
                                *ngIf="isShowCarrierNameByUSDOTOrCADOT"
                              >
                                {{
                                  getCarrierNameByUSDOTOrCADOT(
                                    baggageBound?.carryOnAllowance?.airlineCode,
                                    baggageBound?.carryOnAllowance?.airlineName
                                  )
                                }}
                              </div>
                              <!-- /[1.6.26]-[1.6.16] ルール適用キャリア名 -->
                              <!-- [1.6.26]-[1.6.17] ルール詳細コンテンツ -->
                              <asw-link-label
                                *ngIf="isNhGroupOperatingByUSDOTOrCADOT(baggageBound, CARRYONBAGGAGE)"
                                [class]="'c-plan-table01__col-item c-plan-table01__col-item--fs16'"
                                [label]="'label.cabinBaggageAllownance.nhLink'"
                              ></asw-link-label>
                              <div
                                *ngIf="isNhGroupOperatingByIATARESO302"
                                class="c-plan-table01__col-item c-plan-table01__col-item--fs16"
                                [innerHTML]="
                                  getIsNhGroupOperatingByIATARESO302(CHECKEDBAGGAGE, baggageBound) | staticMsg
                                "
                              ></div>
                              <!-- /[1.6.26]-[1.6.17] ルール詳細コンテンツ -->
                            </div>
                          </td>
                        </ng-container>
                        <!-- <ここまで、運賃ルール・手荷物情報取得API応答.data.baggagePolicies.baggageAllowance.<搭乗者IDリスト[0]>.baggageBounds[]の要素数繰り返し> -->
                      </tr>
                    </thead>
                    <tbody class="c-plan-table01__body">
                      <!-- <以下、PNR情報取得API応答.data.travelers[]の要素数繰り返し>(それぞれの要素が当該搭乗者情報) -->
                      <!-- [1.6.26]-[1.6.18] 搭乗者別ルール -->
                      <ng-container *ngFor="let traveler of orderData.travelers">
                        <tr class="c-plan-table01__inner">
                          <th class="c-plan-table01__col c-plan-table01__col--pb0" scope="row">
                            <div class="c-plan-table01__col-inner">
                              <!-- [1.6.26]-[1.6.19] 搭乗者姓名 -->
                              <div class="c-plan-table01__col-item c-plan-table01__col-item--em">
                                {{ showTravelerName(traveler) | passengerName }}
                              </div>
                              <!-- /[1.6.26]-[1.6.19] 搭乗者姓名 -->
                              <!-- [1.6.26]-[1.6.20] 搭乗者種別 -->
                              <div
                                class="c-plan-table01__col-item"
                                [innerHTML]="passengerLabel(traveler.passengerTypeCode!) | staticMsg"
                              ></div>
                              <!-- /[1.6.26]-[1.6.20] 搭乗者種別 -->
                            </div>
                          </th>
                          <!-- <以下、運賃ルール・手荷物情報取得API応答.data.baggagePolicies.baggageAllowance.<当該搭乗者情報.id>.baggageBounds[]の要素数繰り返し>(それぞれの要素が当該搭乗者情報) -->
                          <ng-container *ngFor="let baggageBound of getBaggageBoundsByPassengerId(traveler.id)">
                            <!-- 2)機内持ち込み手荷物ルールのグループについて、当該適用区間情報.carryOnAllowanceが存在する場合、  当該適用区間情報.carryOnAllowance(以下当該手荷物ルール情報とする) を使用して表示する -->
                            <!-- [1.6.26]-[1.6.21] 区間別ルール -->
                            <td
                              class="c-plan-table01__col c-plan-table01__col--pb0"
                              style="transform: translate(0px, 0px)"
                            >
                              <div class="c-plan-table01__col-inner">
                                <div
                                  class="c-plan-table01__col-item c-plan-table01__col-item--fs16"
                                  *ngIf="isShowCarryOnAllowance(baggageBound)"
                                >
                                  <!-- [1.6.26]-[1.6.22] 無料手荷物個数 -->
                                  <span class="c-my-booking-itinarary__icon-available">
                                    <span
                                      class="c-my-booking-itinarary__icon-available-image"
                                      *ngIf="getAllowanceQuantity(baggageBound, checkedBaggage) !== ''"
                                    >
                                      <img
                                        src="assets/images/icon_feature_not_available_24.svg"
                                        width="24"
                                        height="24"
                                        alt="notFreeBaggageIcon"
                                        *ngIf="quantityCheckedCarryOnAllowance(baggageBound) === 0"
                                      />
                                      <img
                                        src="assets/images/icon_feature_available_24.svg"
                                        width="24"
                                        height="24"
                                        alt="CheckMark"
                                        *ngIf="quantityCheckedCarryOnAllowance(baggageBound) >= 1"
                                      />
                                    </span>
                                    <span class="c-my-booking-itinarary__icon-available-text">
                                      {{ getAllowanceQuantity(baggageBound, carryOnBaggage) }}
                                    </span>
                                  </span>
                                  <!-- /[1.6.26]-[1.6.22] 無料手荷物個数 -->
                                </div>
                              </div>
                            </td>
                            <!-- /[1.6.26]-[1.6.21] 区間別ルール -->
                          </ng-container>
                          <!-- <ここまで、運賃ルール・手荷物情報取得API応答.data.baggagePolicies.baggageAllowance.<当該搭乗者情報.id>.baggageBounds[]の要素数繰り返し> -->
                        </tr>
                        <!-- [1.6.26]-[1.6.23] ルール詳細 -->
                        <ng-container *ngIf="!isShowDetailsByUSDOTOrCADOT && orderData.travelers">
                          <ng-container *ngFor="let bag of bags; index as bagIndex">
                            <tr
                              class="c-plan-table01__inner detail"
                              *ngIf="!isEmptyAllowanceDetails(bagIndex, traveler.id, CARRYONALLOWANCE)"
                            >
                              <th
                                class="c-plan-table01__col c-plan-table01__col--pb0 c-plan-table01__col--not-border"
                                scope="row"
                              >
                                <div class="c-plan-table01__col-inner">
                                  <div class="c-plan-table01__col-item--gray60" [innerHTML]="bag | staticMsg"></div>
                                </div>
                              </th>
                              <!-- <以下、運賃ルール・手荷物情報取得API応答.data.baggagePolicies.baggageAllowance.<当該搭乗者情報.id>.baggageBounds[]の要素数繰り返し>(それぞれの要素が当該搭乗者情報) -->
                              <ng-container *ngFor="let baggageBound of getBaggageBoundsByPassengerId(traveler.id)">
                                <td
                                  class="c-plan-table01__col c-plan-table01__col--pb0 c-plan-table01__col--not-border"
                                  style="transform: translate(0px, 0px)"
                                >
                                  <div class="c-plan-table01__col-inner">
                                    <!-- [1.6.26]-[1.6.24] 料金 -->
                                    <div class="c-plan-table01__col-item c-plan-table01__col-item--fs16">
                                      {{ getFeeDetail(baggageBound.carryOnAllowance?.details ?? [], bagIndex) }}
                                    </div>
                                    <!-- /[1.6.26]-[1.6.24] 料金 -->
                                    <!-- [1.6.26]-[1.6.25] フリーテキスト -->
                                    <div
                                      class="c-plan-table01__col-item c-plan-table01__col-item--fs16"
                                      [innerHTML]="
                                        getDescriptionDetail(
                                          baggageBound.carryOnAllowance?.details ?? [],
                                          bagIndex,
                                          CARRYONBAGGAGE
                                        )
                                      "
                                    ></div>
                                    <!-- /[1.6.26]-[1.6.25] フリーテキスト -->
                                  </div>
                                </td>
                              </ng-container>
                              <!-- <ここまで、運賃ルール・手荷物情報取得API応答.data.baggagePolicies.baggageAllowance.<当該搭乗者情報.id>.baggageBounds[]の要素数繰り返し> -->
                            </tr>
                          </ng-container>
                        </ng-container>
                        <!-- /[1.6.26]-[1.6.23] ルール詳細 -->
                      </ng-container>
                      <!-- /[1.6.26]-[1.6.18] 搭乗者別ルール -->
                      <!-- <ここまで、PNR情報取得API応答.data.travelers[]の要素数繰り返し> -->
                    </tbody>
                  </table>
                </div>
              </div>
            </asw-table-slider>
          </div>
        </div>
      </div>
      <!-- /[1.6.26] 機内持ち込み手荷物ルール -->
    </ng-container>
    <!-- /[1.6.11] 手荷物ルール -->

    <!-- [1.6.2] 手荷物ルール表示不可案内 -->
    <div class="c-my-booking-itinarary-baggage-rules" *ngIf="isBaggageRulesDisplayed">
      <div class="p-plan-table">
        <div class="p-plan-table__contents">
          <img src="assets/images/icon_guidance_red_20.svg" width="24" height="24" alt="" />
          <span [innerHTML]="'label.canNotdisplayedBaggageRules' | staticMsg"></span>
        </div>
      </div>
    </div>
    <!-- /[1.6.2] 手荷物ルール表示不可案内 -->
  </div>
</ng-container>
